function uuidV4() {
    return crypto.randomUUID();
}

export { uuidV4 };
//# sourceMappingURL=uuid-v4.js.map
